/** Panel: 12 rows × 32px = 384px list; + `py-1` (8px) + border (2px) → 394px total so the list fits without a scrollbar. Horizontal `px-1` → 248px row; row `px-2` → 232px content (Figma). */
export const DROPDOWN_PANEL_CLASS =
  'flex h-[394px] min-h-[394px] max-h-[394px] w-[256px] min-w-[256px] max-w-[256px] flex-col overflow-hidden rounded-md border border-border bg-popover py-1 px-1 text-popover-foreground shadow-md'

export const DROPDOWN_LIST_CLASS =
  'min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain'

export const ZOOM_LISTBOX_ID = 'zoom-level-listbox'
